import { z } from 'zod';

export const accessTokenResponseSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string().optional()
});

export type AccessTokenResponse = z.infer<typeof accessTokenResponseSchema>;
